import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { DatePicker } from "./DatePicker";

const today = () => new Date().toLocaleDateString("en-CA");
const MODES = ["Cash", "UPI", "Bank Transfer", "Cheque"];

export const EntryDialog = ({ type, entry, onClose, branches, defaultBranch, onSubmit }) => {
  const [f, setF] = useState({});
  useEffect(() => {
    if (entry) setF({ branch_id: entry.branch_id, amount: String(entry.amount), date: entry.date, description: entry.description, mode: entry.mode });
    else if (type) setF({ branch_id: defaultBranch || branches[0]?.id || "", amount: "", date: today(), description: "", mode: "Cash" });
  }, [type, entry, defaultBranch, branches]);

  const isDep = type === "deposit";
  const submit = async (e) => {
    e.preventDefault();
    await onSubmit({ ...f, type, amount: parseFloat(f.amount) });
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <Dialog open={!!type} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="rounded-none sm:max-w-md" data-testid="entry-dialog">
        <form onSubmit={submit} className="space-y-4">
          <DialogHeader>
            <DialogTitle className={`font-display ${isDep ? "text-pos" : "text-neg"}`}>
              {entry ? "Edit " : ""}{isDep ? "Deposit Entry" : "Withdraw Entry"}
            </DialogTitle>
          </DialogHeader>
          <div>
            <Label>Branch</Label>
            <Select value={f.branch_id} onValueChange={(v) => setF({ ...f, branch_id: v })}>
              <SelectTrigger className="mt-1 rounded-none" data-testid="entry-branch-select"><SelectValue placeholder="Select branch" /></SelectTrigger>
              <SelectContent>
                {branches.map((b) => <SelectItem key={b.id} value={b.id} data-testid={`entry-branch-option-${b.id}`}>{b.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Date</Label>
              <DatePicker value={f.date || ""} onChange={(v) => setF({ ...f, date: v })} className="w-full mt-1" testid="entry-date-input" />
            </div>
            <div>
              <Label>Amount (₹)</Label>
              <Input type="number" step="0.01" min="0.01" required value={f.amount || ""} onChange={set("amount")} className="mt-1 rounded-none font-mono" data-testid="entry-amount-input" />
            </div>
          </div>
          <div>
            <Label>Mode</Label>
            <Select value={f.mode} onValueChange={(v) => setF({ ...f, mode: v })}>
              <SelectTrigger className="mt-1 rounded-none" data-testid="entry-mode-select"><SelectValue /></SelectTrigger>
              <SelectContent>{MODES.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Description</Label>
            <Input value={f.description || ""} onChange={set("description")} className="mt-1 rounded-none" data-testid="entry-description-input" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={!f.branch_id} data-testid="entry-submit-button"
              className={`rounded-none w-full ${isDep ? "bg-emerald-600 hover:bg-emerald-700 text-white" : "bg-red-600 hover:bg-red-700 text-white"}`}>
              {entry ? "Update" : "Save"} {isDep ? "Deposit" : "Withdraw"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
